import { LeafletControlComponent } from './controls/leaflet-control/leaflet-control.component';
import { LeafletDragControlComponent } from './controls/leaflet-drag-control/leaflet-drag-control.component';
import { LeafletDrawControlComponent } from './controls/leaflet-draw-control/leaflet-draw-control.component';
import { LeafletFullscreenControlComponent } from './controls/leaflet-fullscreen-control/leaflet-fullscreen-control.component';
import { LeafletLocateControlComponent } from './controls/leaflet-locate-control/leaflet-locate-control.component';
import { LeafletZoomControlComponent } from './controls/leaflet-zoom-control/leaflet-zoom-control.component';
import { LeafletComponent } from './leaflet/leaflet.component';

export const Components = [
	LeafletControlComponent,
	LeafletDragControlComponent,
	LeafletDrawControlComponent,
	LeafletFullscreenControlComponent,
	LeafletLocateControlComponent,
	LeafletZoomControlComponent,
	LeafletComponent,
];
